import React, { useState, useEffect } from 'react';
import Carousel from '../ui/Carousel';
import CurrentEventCard from '../cards/CurrentEventCard';
import { CarouselSkeleton } from '../skeleton/SkeletonSystem';
import {
  CURRENT_EVENTS_ENABLED,
  currentEventTitle,
  currentEventSubtitle,
  currentEvents
} from '../../data/events/currentEvents/currentEventsIndex';
import holidaysData from '../../data/events/holidaysData';
import HolidayModal from '../ui/HolidayModal';
import '../../css/common/CurrentEventsSection.css';
import '../../css/events/Holidays.css';

const CurrentEventsSection = React.forwardRef((props, ref) => {
  const [loading, setLoading] = useState(true);
  const [selectedHoliday, setSelectedHoliday] = useState(null);

  // Simulate loading for demo purposes
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500); // Show skeleton for 1.5 seconds

    return () => clearTimeout(timer);
  }, []);

  const handleViewSchedule = (holidayId) => {
    const holiday = holidaysData.find(h => h.id === holidayId);
    if (holiday) {
      setSelectedHoliday(holiday);
    }
  };

  const closeModal = () => {
    setSelectedHoliday(null);
  };


  if (!CURRENT_EVENTS_ENABLED) {
    return null;
  }

  const renderEventCard = (event) => (
    <CurrentEventCard event={event} onViewSchedule={handleViewSchedule} />
  );

  return (
    <section ref={ref} className="current-events-section">
      <div className="current-events-container">
        <div className="current-events-header">
          <h2 className="section-title" data-aos="fade-up">{currentEventTitle}</h2>
          <p className="section-subtitle" data-aos="fade-up" data-aos-delay="100">{currentEventSubtitle}</p>
        </div>

        <div className="current-events-carousel">
          {loading ? (
            <CarouselSkeleton items={4} itemsPerView={4} showArrows={true} />
          ) : (
            <Carousel
              items={currentEvents}
              renderItem={renderEventCard}
              showArrows={true}
              itemsPerView={4}
              className="carousel--events"
            />
          )}
        </div>
      </div>

      {/* Holiday Modal */}
      <HolidayModal holiday={selectedHoliday} onClose={closeModal} />
    </section>
  );
});

CurrentEventsSection.displayName = 'CurrentEventsSection';

export default CurrentEventsSection;
